export default  {
    ph_Location: 'Please select a province, city, and district.',
    invoice_Location: 'Location',
    form_bussiness_check: 'Please upload your business license',
    form_notice_check: 'Please upload the notice of recognition of general taxpayer',
    apply_type_normal: 'Ordinary invoice application',
    apply_type_vat: 'VAT invoice application',
    expo_name: 'Exbition',
    total_amount: 'Application billing amount',
    '元':"CNY",
    form_taxcode: 'Tax code',
    form_taxcode_check: 'Please enter the correct taxCode',
    form_taxcode_placeholder: 'Please enter the taxCode',
    form_invoice_title: 'Invoice Title',
    form_invoice_title_check: 'Please enter the Invoice Title（Searchable）',
    form_apply_person: 'Invoice applicant',
    form_apply_person_check: 'Please enter the Invoice applicant',
    form_apply_phone: 'Invoice application contact information',
    form_apply_phone_check: 'Please enter the correct phone number',
    form_apply_phone_placeholder: 'Please enter the invoice application contact information',
    form_registeraddress: 'Company registered address',
    form_registeraddress_check: 'Please enter the company registration address',
    form_company_phone: 'company phone',
    form_company_phone_placeholder: 'Please enter the company phone',
    form_bank_name: 'Bank name',
    form_bank_name_check: 'Please enter the Bank name',
    form_bank_num: 'Bank Account',
    form_bank_num_check: 'Please enter the Bank Account',
    click_upload: 'upload',
    upload_img_fail: 'Uploading image failed, please re-upload',
    business_license: 'business license',
    business_license_check: 'Please upload the business license',
    taxpayer_notice: 'General taxpayer identification notice',
	  'taxpayer_notice_tip':'Only general VAT taxpayers identified by the IRS can issue special VAT invoices. Please upload relevant photos or screenshots.',
	  '查看示例图片':'View example picture',
    taxpayer_notice_check: 'Please upload the General taxpayer identification notice',
    take_type: 'take way',
    take_type_post: 'Mailing',
    take_type_post_tips: 'Within 1-2 months, mail it to the address you filled in, mail it to pay, please pay attention to check',
    take_type_hall_get: 'take in the exhibition hall',
    take_type_hall_get_tips: 'Receive an invoice at the service desk during the development period',
    invoice_send_by_email: 'take in Email',
    form_recipient: 'recipient',
    form_recipient_check: 'Please enter the recipient',
    form_recipient_phone: 'phone',
    form_recipient_phone_placeholder: 'Please enter the phone',
    form_recipient_address: 'Detailed address',
    form_recipient_Email: 'Email',
    form_recipient_address_check: 'Fill in the detailed address',
    form_remarks: 'remarks',
    form_remarks_placeholder: ' (Optional)',
    submit_btn: 'submit',
    back: 'back',
    '修改':'Modify',
    '邮箱':'email',
    '请输入正确的邮箱':'Please enter the correct mailbox',
	  '请输入邮箱':'Please enter your mailbox',
    "用于接收电子发票，请填写正确的邮箱":"For receiving electronic invoices, please fill in the correct email",
    '发票申请':'Invoice application',
    '发票信息':'Invoice information',
    '发票详情':'Invoice details',
    '发票领取方式':'Invoice collection method',
    "您的发票申请未通过，原因如下：":"Your invoice application failed for the following reasons:",

    '发票类型':'Invoice type',
    '查看发票详情':'View invoice details',
    '普通发票':'Ordinary invoice',
    '电子普通发票':'Electronic general invoice',
    '增值税发票':'VAT invoice',
    '增值税专用发票':'VAT invoice',
    '申请时间':'Application time',
    '图片附件':'Picture attachment',
    "开票商品明细":"Billing Product Details",
    "审核状态":"Approval Status",
    "发票状态":"Invoice status",
    "领取方式":"Collection method",
    "总计":"Total",
    "邮寄信息":"Mail information",
    "邮件信息":"Email information",
    "申请编号":"Application number",

    "WAITING":"Unbilled",
    "PENDING":"Invoicing",
    "PENDING_CHECK":"Invoice successfully signed",
    "FAILED":"Invoice failed",
    "FINISH":"Invoiced",
    "CHECK_FAILED":"Invoice signing failed",
    "PENDING_INVALID":"Void",
    "VOID_FAIL":"Invalidation failed",
    "INVALID":"out of date",
    "WAIT_CANCEL":"Invoice at red",
    "CANCELED":"Invoice flushed red",
    "CANCEL_FAIL":"Invoice red failed",

    "请提供正确的一般纳税人通知书":"Please provide correct general taxpayer notice",
    "申请成功":"Application successful",
    "修改成功":"Successfully modified",
  }



// WEBPACK FOOTER //
// ./src/i18n/en-us/invoice_apply.js